<template>
  <div class="org-selector" :class="{ compact }">
    <div v-if="!compact">
      <p v-if="error" class="error">
        {{ errorMessage }}
      </p>
      <router-link v-if="error" to="login">Back to login</router-link>
      <md-card>
        <md-progress-bar v-if="loading" md-mode="query" />
        <div class="org-selection-card-content">
          <md-card-content>
            <img
              src="../../assets/images/VRP_logo_Horizontal.jpg"
              alt="VRpatients Logo"
              class="vrp-logo"
            >
            <p class="prompt blue-5 border">Please select an organization</p>
            <md-field>
              <label>Organization</label>
              <md-select
                :value="state.selectedOrg._id"
                @input="(orgId) => selectOrg(orgId)"
              >
                <md-option
                  v-for="org in orgGroups"
                  :key="org._id"
                  class="org-option"
                  :value="org._id"
                  :disabled="isOrgDisabled(org._id)"
                  :class="{disabled: isOrgDisabled(org._id)}"
                >
                  {{ org.name }}
                </md-option>
              </md-select>
            </md-field>
          </md-card-content>
          <md-card-actions md-alignment="left">
            <md-button
              :disabled="loading"
              :class="{ 'blue-5 bg': !loading }"
              class="md-raised"
              @click="changeActiveOrg(state.selectedOrg._id)"
            >
              <span>Sign in with {{ state.selectedOrg.name }}</span>
            </md-button>
          </md-card-actions>
        </div>
      </md-card>
    </div>
    <div v-if="compact">
      <md-menu md-direction="bottom-end">
        <md-progress-spinner
          v-if="loading"
          :md-stroke="3"
          :md-diameter="10"
          md-mode="indeterminate"
        />
        <slot name="trigger" md-menu-trigger />
        <md-menu-content>
          <!-- eslint-disable vue/no-use-v-if-with-v-for -->
          <md-menu-item
            v-for="org in orgGroups"
            v-if="orgGroups.length >= 2"
            :key="org._id"
            class="org-option"
            :disabled="isOrgDisabled(org._id)"
            :class="{disabled: isOrgDisabled(org._id)}"
            @click="changeActiveOrg(org._id)"
          >
            {{ org.name }}
          </md-menu-item>
          <slot name="after-menu" />
        </md-menu-content>
      </md-menu>
      <p v-if="error" class="error">
        {{ errorMessage }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'org-selector',
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default: null,
    },
    orgGroups: {
      type: Array,
      default: () => [],
    },
    user: {
      type: Object,
      required: true,
    },
    subscriptionState: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      state: {
        selectedOrg: null,
      },
    };
  },
  computed: {
    errorMessage() {
      if (!this.error) {
        return;
      }
      return (
        this.error.message ||
        this.error.errorDescription ||
        'Unkown error during org selection'
      );
    },
  },
  created() {
    this.state.selectedOrg = this.orgGroups[0];
  },
  methods: {
    async changeActiveOrg(orgId) {
      this.$emit('changeActiveOrg', orgId);
      const org = this.orgGroups.find((org) => org._id === orgId);
      this.$analytics.event('Login', 'switch_org', org.name, undefined, {
        org_leaving: this.orgGroups[0].name,
        org_entering: org.name,
      });
    },
    selectOrg(orgId) {
      this.state.selectedOrg = this.orgGroups.find((org) => org._id === orgId);
    },
    // eslint-disable-next-line no-unused-vars
    isOrgDisabled(orgId) {
      // Disable student purchase:
      // const userAppMetadata = this.user['https://vrpatients.com/app_metadata'];
      // if (userAppMetadata && userAppMetadata.subscribedOrgs && userAppMetadata.subscribedOrgs[orgId] && !userAppMetadata.subscriptionActive) {
      //   return true;
      // }
      return false;
    }
  },
};
</script>

<style>
.org-selector.compact p.error {
  margin: 0;
}
.org-selection-card-content {
  min-width: 400px;
  padding: 50px 65px;
}
.org-selector .vrp-logo {
  max-width: 250px;
}

.org-option.disabled span,
.org-option.disabled div {
  text-decoration: line-through;
}

.org-selector .prompt {
  width: auto;
  font-size: 28px;
  font-weight: bold;
  border-bottom: solid 4px;
  padding-bottom: 6px;
}
</style>
